//disable buy now button for offer items
document.addEventListener("DOMContentLoaded", function () {
 // alert(window.location.pathname);
    if (!document.body.classList.contains('template-product')) return;
    const buyNowBtn = document.querySelector('.shopify-payment-button__button');
    const tagInput = document.querySelector('input[name="offer_tags"]');
    const quantityInput = document.querySelector('input[name="quantity"]');
    // Convert Shopify-escaped tags to a usable array
    function getTagList() {
      //const rawTags = tagInput.value;
      const rawTags = tagInput ? tagInput.value : "";
      return rawTags;
    }

function checkAndDisableBuyNow() {
  const tags = getTagList();
  const qty = parseInt(quantityInput.value) || 1;
  if (!buyNowBtn) return; // exit early if button not found
  if (tags.includes("buy-2-get-1") && qty >= 3) {
    buyNowBtn.disabled = true;
  } else if (tags.includes("buy-1-get-1") && qty >= 2) {
    buyNowBtn.disabled = true;
  } else {
    buyNowBtn.disabled = false;
  }
}

    // Handle all quantity buttons dynamically
    document.querySelectorAll('.quantity__button').forEach(button => {
      button.addEventListener('click', function () {
        setTimeout(checkAndDisableBuyNow, 100); // Allow time for DOM update
      });
    });
    // Also handle manual input (optional)
    quantityInput.addEventListener('input', checkAndDisableBuyNow);
    // Run check on load too
    checkAndDisableBuyNow();
  });
//end code


document.addEventListener("click", function (e) {
  // Use closest() to check if the clicked element or any of its parents has the class 'button_offer_item'
  const button = e.target.closest(".button_offer_item");
  if (button) {
   addLoadingEffect(button);
    // Get the data-itemid from the clicked button
    let itemId = button.getAttribute("data-itemid");
    // Construct the input names using itemId
    let offerTagsInput = document.querySelector(`input[name="offer_tags_${itemId}"]`);
    let vendorNameInput = document.querySelector(`input[name="vendor_name_${itemId}"]`);
    let priceInput = document.querySelector(`input[name="price_${itemId}"]`);
    let titleInput = document.querySelector(`input[name="title_${itemId}"]`);
    let featuredImageInput = document.querySelector(`input[name="featured_image_${itemId}"]`);
    // Get values (if input exists, else return an empty string)
    let offerTags = offerTagsInput ? offerTagsInput.value : "";
    let vendorName = vendorNameInput ? vendorNameInput.value : "";
    let price = priceInput ? priceInput.value : "";
    let title = titleInput ? titleInput.value : "";
    let featuredImage = featuredImageInput ? featuredImageInput.value : "";
    price = parseFloat(price);
    price = price / 100;
    // Call your function with the collected data
    initiateOfferAddtoCart(itemId, 1, offerTags, price, featuredImage, title, vendorName, button, "catlog");
  }
});

// 1. Define your handler function
function handleMiniCartOfferClick(e) {
  const mini_cart_button = e.target.closest(".mini_button_offer_item");
  if (!mini_cart_button) return;

  // Prevent multiple triggers (e.g., double clicks or binding issue)
  if (mini_cart_button.classList.contains("clicked")) return;
  mini_cart_button.classList.add("clicked");

  // Get the data-itemid
  let itemId = mini_cart_button.getAttribute("data-itemid");

  // Fetch inputs based on itemId
  let offerTagsInput = document.querySelector(`input[name="offer_tags_${itemId}"]`);
  let vendorNameInput = document.querySelector(`input[name="vendor_name_${itemId}"]`);
  let priceInput = document.querySelector(`input[name="price_${itemId}"]`);
  let titleInput = document.querySelector(`input[name="title_${itemId}"]`);
  let featuredImageInput = document.querySelector(`input[name="featured_image_${itemId}"]`);

  // Get values
  let offerTags = offerTagsInput ? offerTagsInput.value : "";
  let vendorName = vendorNameInput ? vendorNameInput.value : "";
  let price = priceInput ? parseFloat(priceInput.value) / 100 : 0;
  let title = titleInput ? titleInput.value : "";
  let featuredImage = featuredImageInput ? featuredImageInput.value : "";

  // Optional loading effect
  addLoadingEffect(mini_cart_button);

  // Call your offer function
  initiateOfferAddtoCart(itemId, 1, offerTags, price, featuredImage, title, vendorName, mini_cart_button, "minicart");

  // Optionally remove the "clicked" flag after a timeout or success
  setTimeout(() => {
    mini_cart_button.classList.remove("clicked");
  }, 2000);
}

// 2. Only bind once globally
if (!window._miniCartClickBound) {
  document.addEventListener("click", handleMiniCartOfferClick);
  window._miniCartClickBound = true;
}




//end

//handling add to cart button in product details page
document.addEventListener("DOMContentLoaded", function() {
  // freeItems array to store our items
/**
 * Updates the freeItems array by adding a new item or updating an existing one.
 *
 * @param {string|number} variationId - The unique identifier for the item.
 * @param {number} qty - The quantity to add or remove.
 * @param {string} action - The action to perform ('add' to increase, 'remove' to decrease).
 */
    var offerButton = document.getElementById("OfferProductSubmitButton");
    if (offerButton) {
      //this function will add free items for same items
      offerButton.addEventListener("click", function(event) {
        this.classList.add("loading");
       var spinner = this.querySelector(".loading__spinner");
      if (spinner) {
        spinner.classList.remove("hidden");
      }
        event.preventDefault(); // Prevent the default action
         addLoadingEffect();
        // Get the variant id and convert it to a number
        var idTextbox = document.querySelector('input[name="offer_product_id"]');
        var variantId = idTextbox ? idTextbox.value : null;
        // Get the quantity value and convert it to a number (default to 1)
        var quantityTextbox = document.querySelector('input[name="quantity"]');
        var quantity = quantityTextbox ? parseInt(quantityTextbox.value, 10) : 1;
        // Get the offer tags from the textbox with name="offer_tags"
        var offerTagsTextbox = document.querySelector('input[name="offer_tags"]');
        var vendorTextbox = document.querySelector('input[name="vendor_name"]');
        var priceTextbox = document.querySelector('input[name="price"]');
        var imageTextbox = document.querySelector('input[name="featured_image"]');
        var titleTextbox = document.querySelector('input[name="title"]');
        var productPrice = priceTextbox ? priceTextbox.value : null;
        var image_url = imageTextbox ? imageTextbox.value : null;
        var title = titleTextbox ? titleTextbox.value : null;
        productPrice = parseFloat(productPrice);
        productPrice = productPrice / 100;
        var tagValue = offerTagsTextbox ? offerTagsTextbox.value : null;
        var vendorValue = vendorTextbox ? vendorTextbox.value : null;
       initiateOfferAddtoCart(variantId,quantity,tagValue,productPrice,image_url,title,vendorValue,offerButton,"main");
      });
    }
  });

function initiateOfferAddtoCart(variantId,quantity,tagValue,productPrice,image_url,title,vendorValue,offerButton,page){
   if(tagValue.indexOf("buy-2-get-1") > -1) {
            var vendorTag='buy-2-get-1';
          }else if(tagValue.indexOf("buy-1-get-1") > -1) {
            var vendorTag='buy-1-get-1';
          }  
        checkSameVendorItemsInCart(vendorValue, variantId, quantity, vendorTag, productPrice)
    .then(lowestPriceItem => {
       // console.log("Final lowest item:", lowestPriceItem);
         //check eligible for free items
     //alert('same vendor items found');
        //check if we need to remove existing cart items from same vendor if price is low compared to the free item going to add to cart
        if(lowestPriceItem && productPrice > lowestPriceItem.price && quantity==lowestPriceItem.quantity){
         // alert("same vendor exists and need to remove");
          //function to switch existing cart items as free and new product as main item
          switchCartItems(variantId,productPrice,quantity,lowestPriceItem,"remove",vendorTag);
          addToCartofferItemstocart(variantId,quantity,tagValue,image_url,title,productPrice,offerButton,page,vendorValue,lowestPriceItem);
        }else if(lowestPriceItem && productPrice > lowestPriceItem.price && quantity< lowestPriceItem.quantity){
          // alert("I am here 33333 ");
            switchCartItems(variantId,productPrice,quantity,lowestPriceItem,"switch",vendorTag);
             setTimeout(function () {
                      //console.log("Function executed after 4 seconds");
                      addToCartofferItemstocart(variantId,quantity,tagValue,image_url,title,productPrice,offerButton,page,vendorValue,lowestPriceItem);
                  }, 2000);
             
        }else if(lowestPriceItem && productPrice <= lowestPriceItem.price && quantity==lowestPriceItem.quantity && vendorTag=='buy-1-get-1'){
           //alert("low price ");
             addFreeItemsForSameVendor(variantId,quantity,productPrice,image_url,vendorValue,title,lowestPriceItem.variantId,vendorTag);
             showFreeItemsInCart(); //shpw free items in cart
             openCartDrawer();
          if(page=="main"){
            var id='';
          }else{
             var id=variantId;
          }
        hideLoadingEffect(id,page);
        }else{
        // alert("Existing item not found");
          addToCartofferItemstocart(variantId,quantity,tagValue,image_url,title,productPrice,offerButton,page,vendorValue,lowestPriceItem);
        }
        
    })
    .catch(error => console.error("Error:", error));
}

//function will check if new items trying to add is eligible for free or not
function searchSameVendorFreeItems(variantId,quantity) {
 // console.log(cart);
  return;
}

/* function to add free item from same vendor if it is eligible */
function addFreeItemsForSameVendor(variantId,quantity,price,image_url,vendorValue,title,parentId,vendorTag){
    updateFreeItems(variantId,quantity,'add',title,image_url,vendorValue,price,parentId,vendorTag);
}

//function adjust loadedcartitems localstoreage
function loadedCartItemsLocalStorage(qty,variantId){
  // Ensure you load the cart data from localStorage, with fallback to an empty object or array
const cartData = localStorage.getItem("loadedCartItems");
  //console.log("Before cat local storegae update: ", cartData);
let cart = cartData ? JSON.parse(cartData) : { items: [] };  // Default to an object with `items` array

// Check if cart is the expected type (array of items or object)
if (!cart.items) {
 // console.warn("Cart data structure is incorrect. Reinitializing.");
  cart = { items: [] };  // Default cart structure with an empty array for items
}

// Now you can safely manipulate the `cart.items` array
const variantIdToUpdate = variantId;
const newQuantity = qty;  // Update as needed

// Update the quantity for the matching item
cart.items = cart.items.map(item => {
  if (item.variant_id == variantIdToUpdate) {
    return { ...item, quantity: newQuantity };
  }
  return item;
});

// Store the updated cart back to localStorage with the same structure
localStorage.setItem("loadedCartItems", JSON.stringify(cart));
 //console.log("After cat local storegae update: ", localStorage.getItem("loadedCartItems"));

  
//end
}

/* function to remove hiegher priced cart items from cart and get its products informations
*/
async function switchCartItems(variantId, productPrice, quantity, lowestPriceItem, action,vendorTag) {
   var updateQty;
      let freeQty;
        if(action=="remove"){
          updateQty=0;
          freeQty=lowestPriceItem.quantity;
        }else{
          updateQty=parseInt(lowestPriceItem.quantity - quantity);
          freeQty=lowestPriceItem.quantity - quantity;
        }
  updateFreeItems(lowestPriceItem.variantId,freeQty,'add',lowestPriceItem.title,lowestPriceItem.image_url,lowestPriceItem.vendor,lowestPriceItem.price,variantId,vendorTag);
  //update localstorage cart object qty
 // Ensure you load the cart data from localStorage, with fallback to an empty object or array
  //alert("updateQty "+updateQty);
 // alert(lowestPriceItem.variantId);
  loadedCartItemsLocalStorage(updateQty,lowestPriceItem.variantId);
//end
  try {
        //console.log(`🚀 Switching Cart Items...`);
        // ✅ Step 1: Remove the known lowest price item from the cart
     
        let removeResponse = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                updates: {
                    [lowestPriceItem.variantId]: updateQty // Remove item by setting quantity to 0
                }
            })
        });
      let removeData = await removeResponse.json();
       //console.log("removeData ", removeData);
       // console.log(`✅ Removed item from cart: Variant ID: ${lowestPriceItem.variantId}, Title: ${lowestPriceItem.title}`);
         //updateFreeItems(variationId,qty,action = 'add',title='',image_url='',vendor='',price='', parentId=0){
          
    } catch (error) {
        //console.error("⚠️ Error switching cart items:", error);
    }
}
async function updateCartItemQuantity(variantId, updateQty) {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: {
          [variantId]: updateQty
        }
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      //console.error("Failed to update cart:", response.status, errorText);
      return;
    }

    const data = await response.json();
    //console.log("Cart updated successfully:", data);
    return data;
  } catch (error) {
   // console.error("Error updating cart:", error);
  }
}


function addLoadingEffect(button=''){
  if(button){
    button.classList.add("loading");
    
    // Find the spinner element inside the button
    const spinner = button.querySelector(".loading__spinner");
    if (spinner) {
      // Add the "hidden" class to the spinner
      spinner.classList.remove("hidden");
    }
  }else{
  const offerButton = document.getElementById("OfferProductSubmitButton");
   document.getElementById("OfferProductSubmitButton").classList.add("loading");
        const spinnerDiv = offerButton.querySelector(".loading__spinner");
        spinnerDiv.classList.remove("hidden");
  }
}
function hideLoadingEffect(id='',page=''){
  if(id){
    if(page=="minicart"){
    var className="."+"mini_quick_add_"+id;
    }else{
      var className="."+"quick_add_"+id;
    }
    const button = document.querySelector(className);
  if (button) {
    // Remove the "loading" class from the button
        button.classList.remove("loading");
        // Find the spinner element inside the button
       const spinner = document.querySelectorAll(".loading__spinner");
        if (spinner) {
          // Add the "hidden" class to the spinner
          spinner.forEach(spinner => {
            spinner.classList.add("hidden");
        });
    }
  }
  }else{
   const offerButton = document.getElementById("OfferProductSubmitButton");
    offerButton.classList.remove("loading");
    const spinnerDiv = offerButton.querySelector(".loading__spinner");
    spinnerDiv.classList.add("hidden");
  }
}
function getTotalExistingVendorItems(vendorTag,vendorValue) {
  const cart = JSON.parse(localStorage.getItem("loadedCartItems"));
        //Fetch Shopify cart
        let vendorTotal = 0; // Total free items eligible based on cart
        // Loop through each cart item
        cart.items.forEach(item => {
            let tags = item.properties?._tags || [];
            if (tags.includes(vendorTag) && vendorValue==item.vendor) {
                vendorTotal += item.quantity; // 1 free for every 2
            } 
        });
      return vendorTotal;
}
//add to cart function for offer items
function  addToCartofferItemstocart(variantId,quantity,tagValue,image_url,title,price,offerButton,page,vendorValue,lowestPriceItem){
  let vendorTag='';
   //alert(variantId);
  if (tagValue && (tagValue.indexOf("buy-2-get-1") > -1 || tagValue.indexOf("buy-1-get-1") > -1)) {
        if(tagValue.indexOf("buy-2-get-1") > -1) {
          vendorTag="buy-2-get-1";
        }
         if(tagValue.indexOf("buy-1-get-1") > -1) {
          vendorTag="buy-1-get-1";
        }
   
          // Fetch the current Shopify cart JSON
          fetch('/cart.js')
            .then(function(response) { return response.json(); })
            .then(function(cartData) {
            // console.log("Cart data:", cartData);
              // Find the item in the cart matching the current variant ID (number comparison)
              var cartItem = cartData.items.find(function(item) {
               // console.log(item.variant_id);
                return item.variant_id == variantId;
              });
              
              // console.log("Cart data:", cartItem);
              // Get the current quantity from the cart for this variant
              let totalFreeQty = 0;
              var parentId=0;
              var currentCartQty = cartItem ? cartItem.quantity : 0;
              let firstTimeStatus = (currentCartQty === 0); //set true or false based on existing cart qty

              // Check: if current cart qty plus new quantity exceeds 2, prevent adding
              var newQty = currentCartQty + quantity;
              //alert("newQty "+newQty);
              let freeQty = getTotalEligbleFreeItems(vendorTag,vendorValue,quantity);
              let totalSameVenor=getTotalExistingVendorItems(vendorTag,vendorValue);
              //alert("totalFreeAvailable "+freeQty);
             //alert("totalSameVenor "+totalSameVenor);
              //check freeQty availabled based on current item going to add cart
              let balanceQty=0;
              if(vendorTag==="buy-1-get-1" && quantity > 1 && quantity > freeQty){
                balanceQty = quantity - freeQty;
                freeQty = freeQty + Math.floor(balanceQty / 2);
              }else if(vendorTag==="buy-2-get-1" && quantity >= 2 && quantity > freeQty){
                if(totalSameVenor > freeQty){
                 
                    balanceQty = totalSameVenor + (quantity - freeQty);
                }else{
                   balanceQty = quantity - freeQty;
                }
                //alert("balanceQty "+balanceQty);
                freeQty = freeQty + Math.floor((balanceQty - 1) / 2)
              }
             // alert("totalFreeAvailable "+freeQty);
             // return false;
              //
               //if (checkEligibleForFree(newQty,variantId,tagValue,vendorValue,lowestPriceItem)==true) {
                if(freeQty > 0){
               //  alert("Free eligibale");
                 //get total elible free items based on selected product vendor and tag
                 //let freeQty = getTotalEligbleFreeItems(vendorTag,vendorValue,quantity);
                 var currentFreeQty = searchItemsInFreeItems(variantId);
                 
                 //if same vendor exist in cart get total eligible free items based on it
                
                 //end 
                 /* var elibiblefreeBasedonSameVedor=0;
                if(tagValue.indexOf("buy-2-get-1") > -1) {
                  var freeQty = Math.floor((newQty - 1) / 2);
                 if(lowestPriceItem && lowestPriceItem.vendor==vendorValue){
                   parentId=lowestPriceItem.variantId;
                   if(lowestPriceItem.quantity>2){
                     elibiblefreeBasedonSameVedor = Math.floor((lowestPriceItem.quantity - 1) / 2);
                   }else if(lowestPriceItem.quantity==2){
                     elibiblefreeBasedonSameVedor = 1;
                   }
                  
                 }
                }else if(tagValue.indexOf("buy-1-get-1") > -1) {
                  var freeQty = Math.floor(newQty / 2);
                } 
                 freeQty = freeQty + elibiblefreeBasedonSameVedor;
                 */
                // alert("free "+freeQty);
                // alert("newQty " + newQty);
                 let totalCartQty = newQty + currentFreeQty;
                 
                 //alert("totalCartQty "+totalCartQty);
                  //if(freeQty > currentFreeQty){
                 if(freeQty >= quantity){
                   //alert("I am new code");
                     const parentId=lowestPriceItem.variantId;
                     updateFreeItems(variantId,quantity,"add",title,image_url,vendorValue,price, parentId,vendorTag);
                     showFreeItemsInCart(); //show free items in cart if available
                      if(page=="minicart"){
                       hideLoadingEffect(variantId);
                      }else{
                        hideLoadingEffect();
                      }
                 }else if(freeQty <  quantity){ 
                   quantity = quantity - freeQty;
                   if(page=="main"){
                    
                        var quantityTextbox = document.querySelector('input[name="quantity"]');
                        quantityTextbox.value = quantity;
                        document.querySelector('.product-form__submit').click();
                        hideLoadingEffect();
                        setTimeout(function () {
                            //const vendor='';
                            const parentId=0;
                          //var eligibaleFree = freeQty - currentFreeQty;
                           updateFreeItems(variantId,freeQty,"add",title,image_url,vendorValue,price, parentId,vendorTag);
                          //updateFreeItems(variationId,qty,action = 'add',title='',image_url='',vendor='',price='', parentId=0){
                          
                       // console.log("Function executed after 4 seconds");
                        showFreeItemsInCart(); // Call your function here
                      }, 3000);
                      }
                }else{
                     
                     document.querySelector('.product-form__submit').click();
                     hideLoadingEffect();
                     //addFreeItem(variantId); //show free items in mini cart drawer
                     //showFreeItemsInCart() //show free items in cart if available
                      setTimeout(function () {
                        //console.log("Function executed after 4 seconds");
                        showFreeItemsInCart(); // Call your function here
                      }, 4000);
                  }
                 
               } else {
                 
                // Otherwise, submit the form to add the item to the cart.
                var form = offerButton.closest("form");
                if (form) {
                 
                 // form.submit();
                 
                  if(page=="main"){
                    document.querySelector('.product-form__submit').click();
                    hideLoadingEffect();
                   }else if(page=="minicart"){
                  // alert("ffffffffff");
                    var className="."+"quick_add_"+variantId;
                    document.querySelector(className).click();
                     hideLoadingEffect(variantId);
                  }else{
                    var className="."+"quick_add_"+variantId;
                   
                    //alert(className);
                    document.querySelector(className).click();
                     hideLoadingEffect(variantId);
                  }
                  //showFreeItemsInCart();
                  setTimeout(function () {
                      //console.log("Function executed after 4 seconds");
                      showFreeItemsInCart(); // Call your function here
                  }, 4000);
                  //end
                }
              }
            })
            .catch(function(error) {
             // console.error("Error fetching cart data:", error);
              // Optionally, you may choose to allow the add-to-cart action if there's an error
              var form = offerButton.closest("form");
              if (form) {
               // form.submit();
              }
            });
        } else {
          // If the offer tag doesn't contain "buy-2-get-1", submit the form normally.
          var form = offerButton.closest("form");
          if (form) {
            form.submit();
          }
        }
}
async function customAddToCart(variantId, qty = 1) {
    try {
        let response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ quantity: qty, id: variantId })
        });

        let data = await response.json();
        if (!response.ok) {
            //throw new Error(`❌ Error: ${data.message || "Failed to add item"}`);
        }

       // console.log(`✅ Added to cart: Variant ID ${variantId}, Quantity ${qty}`);
        return data;
    } catch (error) {
       // console.error(error.message);
        return null;
    }
}
//function to get total eligibale free items based on its tag
  function getTotalEligbleFreeItems(vendorTag,vendorValue,quantity,action='add') {
    //var loadedCartItems = localStorage.getItem("loadedCartItems");
    const cart = JSON.parse(localStorage.getItem("loadedCartItems"));
    //console.log("Loaded cart items ", cart);
   // alert(vendorTag);
   // alert(vendorValue);
        //Fetch Shopify cart
     
        //console.log("Cart loaded:", cart.items);

        let eligibleFreeTotal = 0; // Total free items eligible based on cart
        let cartFreeItems = JSON.parse(localStorage.getItem("freeItems")) || []; // Stored free items
        let totalBuy2Get1=0;
        // Loop through each cart item
        cart.items.forEach(item => {
            let tags = item.properties?._tags || [];

            if (tags.includes("buy-2-get-1") && vendorValue==item.vendor) {
                //eligibleFreeTotal += Math.floor(item.quantity / 2); // 1 free for every 2
                totalBuy2Get1 += item.quantity; // 1 free for every 2
            } 
            if (tags.includes("buy-1-get-1") && vendorValue==item.vendor) {
                eligibleFreeTotal += item.quantity; // 1 free for every 1
            }
        });
        //totalBuy2Get1 = 3;
        totalBuy2Get1 = Math.floor(totalBuy2Get1 / 2);
   
        eligibleFreeTotal += totalBuy2Get1;
     //alert('eligibleFreeTotal free '+ eligibleFreeTotal);
        //alert('current free '+ Qty);
        //get existing free items based on vendor
           var Qty=0;
          cartFreeItems.forEach((item, index) => {
           //if(variantId==item.variationId){
           if(vendorValue==item.Vendor && vendorTag==item.Tag ){
             Qty = item.Qty + Qty;
           }
        });
     // alert('current free '+ Qty);
      let totalFreeAvailable=0;
      if(parseInt(eligibleFreeTotal) >= parseInt(Qty) && action=="add"){
        totalFreeAvailable = parseInt(eligibleFreeTotal) - parseInt(Qty);
      }else if(parseInt(eligibleFreeTotal) < parseInt(Qty) && action=="add"){
        totalFreeAvailable=0;
      }else{
        totalFreeAvailable=parseInt(eligibleFreeTotal);
      }
    return totalFreeAvailable;
        // Calculate current free items from localStorage
        


    
}

function checkEligibleForFree(quantity,variantId,tags,vendorValue,lowestPriceItem){
  //if tags contain buy-1-get-1-free then if quantity is greater than 1 then eligibale for free
  //if tags contain buy-2-get-1-free then if quantity is greater than multiplier of 2 then eligibale for free
  //if elegible return true
  if (!tags || typeof tags !== "string") {
    return false;
  }
  if(lowestPriceItem && vendorValue==lowestPriceItem.vendor){
    quantity = quantity + lowestPriceItem.quantity;
  }
  // For a "buy-1-get-1-free" promotion:
  // If the tags string contains "buy-1-get-1-free", then if the quantity is greater than 1, return true.
  if (tags.includes("buy-1-get-1")) {
    if (parseInt(quantity) > 1) {
      return true;
    }
  }
  
  // For a "buy-2-get-1-free" promotion:
  // If the tags string contains "buy-2-get-1-free", then if the quantity is greater than or equal to 2, return true.
  // (This assumes that buying 2 items makes you eligible for one free item.
  //  Adjust the condition if your promotion rule is different.)
   if (tags.includes("buy-2-get-1")) {
         var eligibleStatus = getEligibleFreeItems(quantity,variantId,vendorValue);
         //alert(eligibleStatus);
         if(eligibleStatus==true){
             return true;
         }else if(lowestPriceItem){
           //alert("ddddddddddddd");
           //check free items eligible based on same vendor but different items
           var eligibleStatus=getEligibleFreeItemsDiffentVednor("buy-2-get-1",quantity,variantId,vendorValue,lowestPriceItem);
           if(eligibleStatus==true){
             return true;
           }
         }else{
         }
    }
  
  // If none of the conditions are met, return false.
  return false;
  
}
function getEligibleFreeItemsDiffentVednor(tag,quantity,variantId,vendorValue,lowestPriceItem){
 //alert("getEligibleFreeItemsDiffentVednor");
 // console.log("lowestPriceItem: ", lowestPriceItem);
  let totalQty=parseInt(quantity) + parseInt(lowestPriceItem.quantity);
  var freeQty = Math.floor((totalQty - 1) / 2);
  //alert("FReeeee "+ freeQty);
  if(freeQty>0){
    return true;
  }else{
    return false;
  }
}
function getEligibleFreeItems(quantity,variantId,vendorValue) {
    // if (quantity < 3 || quantity % 2 === 0) {
    //     return 0; // Only odd numbers 3 and above are eligible
    // }
  if (quantity < 3) {
        return 0; // Only odd numbers 3 and above are eligible
    }
    var freeQty = Math.floor((quantity - 1) / 2);
   //alert("getEligibleFreeItems" +freeQty);
    const STORAGE_KEY = 'freeItems';
    // Load freeItems from localStorage or start with an empty array
    var freeItems = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
   // Retrieve and parse 'freeItems' from localStorage
  if(freeItems.length==0){
    return true;
  }
  // Loop through each item and log variantId and qty
  var current_qty = searchItemsInFreeItems(variantId);
  if(current_qty==0 || current_qty < freeQty){
    return true;
  }else{
    return false;
  }
 
}
function searchItemsInFreeItems(variantId) {
    const STORAGE_KEY = 'freeItems';
    // Load freeItems from localStorage or start with an empty array
    var freeItems = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    var Qty=0;
    freeItems.forEach((item, index) => {
     //if(variantId==item.variationId){
     if(variantId==item.ParentId ){
       Qty = item.Qty + Qty;
     }
  });
  return Qty;
}


//function to add free item html in mini cart
function checkFreeitemExists(variantId){
  var cartTable = document.querySelector("table.cart-items");
    if (!cartTable) {
      //console.warn("Cart table not found.");
      return false;
    }
    // Look for a <tr> element with a matching data-free-for attribute value
    var freeItemRow = cartTable.querySelector('tr[data-free-for="' + variantId + '"]');
    return freeItemRow !== null;
}

function addFreeItemMainCart(item) {
  // Destructure properties from the item object
  const variantId = item.variationId;
  const qty = item.Qty;
  let image_url = item.ImageUrl;
  let price = item.Price;
  let title = item.Title;
  const parent_id = item.ParentId;
  //alert(parent_id);
  // Select the original row inside the main cart table using its data-itemid attribute
  let originalTr = document.querySelector('.main-cart-items tr[data-itemid="' + parent_id + '"]');
  if (!originalTr) {
    //console.error("Original row not found for data-itemid:", parent_id);
    //return;
  }
    // ✅ Fallback: If original row not found, use the last cart item row
  if (!originalTr) {
    const allRows = document.querySelectorAll('.main-cart-items tr[data-itemid]');
    if (allRows.length > 0) {
      originalTr = allRows[allRows.length - 1];
    } else {
      return;
    }
  }
    // ✅ Fallback: If original row not found, use the last cart item row

    // If the parent's row is not found, use the last cart item as a fallback template

  
  // Get parent's details in case any free item detail is missing
  const parentNameEl = originalTr.querySelector(".cart-item__name");
  const parentPriceEl = originalTr.querySelector('.cart-item__price-wrapper .price--end');
  const parentImageEl = originalTr.querySelector(".cart-item__image");
  
  if (!title && parentNameEl) {
    title = parentNameEl.textContent.trim();
  }
  
  // If price is missing or not a number, get parent's total price and calculate unit price
  if (!price || isNaN(price)) {
    if (parentPriceEl) {
      // Parse parent's total price from text (removing non-digit characters)
      let totalPrice = parseFloat(parentPriceEl.textContent.replace(/[^\d\.]/g, ''));
      // Get parent's quantity from the input field
      let parentQtyEl = originalTr.querySelector(".quantity__input");
      let parentQty = parentQtyEl ? parseFloat(parentQtyEl.value) : 1;
      if (parentQty && totalPrice) {
        // Calculate single item price
        price = totalPrice / parentQty;
      } else {
        price = 0;
      }
    }
  }
  
  if (!image_url && parentImageEl) {
    image_url = parentImageEl.getAttribute('src') || parentImageEl.getAttribute('data-src');
  }
  
  // Clone the original <tr> so we can modify it for a free item
  const freeTr1 = originalTr.cloneNode(true);
  
  // Update the row's id to ensure uniqueness
  freeTr1.id = originalTr.id + "-free-" + variantId;
  var freeItemId = freeTr1.id;
    var existingFreeTr = document.getElementById(freeItemId);
    if (existingFreeTr) {
        existingFreeTr.remove();
    }


  
  // Update data attributes: if the free variant differs from the parent, update data-itemid as well
  if (variantId !== parent_id) {
    freeTr1.setAttribute("data-free-for", variantId);
    freeTr1.setAttribute("data-itemid-free", variantId);
  } else {
    freeTr1.setAttribute("data-free-for", parent_id);
    freeTr1.setAttribute("data-itemid-free", variantId);
  }
  
  // Remove unwanted elements from the clone:
  // Remove the quantity-popover (if present) to avoid duplicate controls
  const quantityPopover = freeTr1.querySelector("quantity-popover");
  if (quantityPopover) {
    quantityPopover.remove();
  }
  
  // Remove the product-tags container so the free item doesn't show original tags
  const productTags = freeTr1.querySelector(".product-tags");
  if (productTags) {
    productTags.remove();
  }
  
  // Remove the entire price wrapper element(s)
  freeTr1.querySelectorAll('.cart-item__price-wrapper').forEach(el => el.remove());
  
  // Calculate the free total based on the (unit) price and free item quantity
  let freeTotal = parseFloat(price) * qty;
  let formattedTotal = freeTotal.toFixed(2);
  
  // Update the product name to include free item details and total price
  const productNameEl = freeTr1.querySelector(".cart-item__name");
  if (productNameEl) {
    productNameEl.textContent = title + " (" + qty + " x Free) - QAR " + formattedTotal;
  }
  
  // Update the product image if a new image URL is provided (or use parent's)
  const productImageEl = freeTr1.querySelector(".cart-item__image");
  // if (productImageEl) {
  //   productImageEl.setAttribute('src', image_url);
  //   productImageEl.setAttribute('data-src', image_url);
  //   productImageEl.alt = title;
  // }
  const fallbackImage = "https://raf-pharmacy.myshopify.com/cdn/shop/files/place_holder-back_ad_white.png?v=1738557147&width=100";

// Check if image_url is valid
   
    if (productImageEl) {
       const safeImageUrl = getSafeImageUrl(image_url);
     // productImageEl.src = image_url;
      productImageEl.src = safeImageUrl;
      productImageEl.alt = title;
      //  productImageEl.onerror = function () {
      //   this.onerror = null;
      //   this.src = fallbackImage;
      // };
    }
  
  // Update the quantity input field to reflect the free item's quantity
  const productQtyEl = freeTr1.querySelector(".quantity__input");
  if (productQtyEl) {
    productQtyEl.value = qty;
  }
  
  // Update the remove button's id to avoid duplication conflicts
  const cartRemoveButton = freeTr1.querySelector("cart-remove-button");
  if (cartRemoveButton) {
    cartRemoveButton.id = cartRemoveButton.id + "-free-" + variantId;
  }
  
  // Remove all cart buttons except the delete option
  const cartButtonsUl = freeTr1.querySelector('ul.cart_buttons');
  if (cartButtonsUl) {
    cartButtonsUl.querySelectorAll('li').forEach(li => {
      if (!li.querySelector('cart-remove-button')) {
        li.remove();
      }
    });
  }
  
  // Optionally add a class to style free items differently
  freeTr1.classList.add("free-item");
   freeTr1.classList.add("remove-"+variantId);
    // Replace product-option text with "Free"
const productOptionEl = freeTr1.querySelector('.product-option');
if (productOptionEl) {
  productOptionEl.textContent = 'Free';
}
  // Insert the new free row immediately after the original row in the main cart table
  originalTr.parentNode.insertBefore(freeTr1, originalTr.nextSibling);
}
function addFreeItem_old(item){
   //console.log("addFreeItem function", item);
  //if user in cart page call function to show free items in cart page
 addFreeItemMainCart(item);
  //if (window.location.pathname == '/cart') {
    //return false;
  //}
  
  var variantId=item.variationId;
  var qty = item.Qty;
  var image_url = item.ImageUrl;
  var price = item.Price;
  var title=item.Title;
  var parent_id = item.ParentId;
  //console.log("addFreeItem item 123333:", item);
   // var knownDataItemId = variantId;
   var knownDataItemId = parent_id;
     // Locate the original <tr> element using its data-itemid attribute
    var originalTr = document.querySelector('tr[data-itemid="' + knownDataItemId + '"]');
    if (!originalTr) {
      removeFreeItems(knownDataItemId, eligibleFree = 0);
      //console.log("Original tr not found for data-itemid " + knownDataItemId);
      return;
    }
    // Get the innerHTML of the original <tr>
    var originalHTML = originalTr.innerHTML;
    // Create a temporary container to manipulate the HTML
    var tempContainer = document.createElement("div");
    tempContainer.innerHTML = originalHTML;
    // Remove the quantity-popover element and its contents if it exists
    var quantityPopover = tempContainer.querySelector("quantity-popover");
    if (quantityPopover) {
      quantityPopover.remove();
    }
    
    // Remove the product-tags div and its contents
    var productTags = tempContainer.querySelector("div.product-tags");
    if (productTags) {
      productTags.remove();
    }
    
    // Update the product option text to show "Free"
    var productOptionEl = tempContainer.querySelector(".product-option");
    if (productOptionEl) {
      //productOptionEl.textContent = "Free";
      productOptionEl.textContent = "Free (QAR " + price + ")";
    }

  var cartRemoveButton = tempContainer.querySelector("cart-remove-button");
  if (cartRemoveButton) {
        let oldId = cartRemoveButton.id;
        let newId = oldId + "-free-"+variantId; // e.g., CartDrawer-Remove-1-free
        cartRemoveButton.id = newId;
  }
    // Optionally, update the product name to indicate it's a free item.
    var productNameEl = tempContainer.querySelector(".cart-item__name");
    if (productNameEl) {
      productNameEl.textContent += " ("+ qty +" x Free)";
    }

    //change image, title and price for different items free
  if (variantId !== parent_id) {
        //console.log("🔄 Updating Free Item Details: New Title, Image, Price, and Quantity.");

        // ✅ Update Product Name
        var productNameEl = tempContainer.querySelector(".cart-item__name");
        if (productNameEl) {
            productNameEl.textContent = title + " (" + qty + " x Free)";
        }

        // ✅ Update Price
        // var productPriceEl = tempContainer.querySelector(".product-option");
        // if (productPriceEl) {
        //     productPriceEl.textContent = "Free (QAR " + price + ")";
        // }

        // ✅ Update Image
        var productImageEl = tempContainer.querySelector(".cart-item__image");
        // if (productImageEl) {
        //     productImageEl.src = image_url;
        //     productImageEl.alt = title;
        // }

        const fallbackImage = "https://raf-pharmacy.myshopify.com/cdn/shop/files/place_holder-back_ad_white.png?v=1738557147&width=100";

// Check if image_url is valid
   
    const isValidImageUrl = (url) => {
      return typeof url === 'string' && url.startsWith('http') && !url.includes('Liquid error');
    };
    if (productImageEl) {
      
     // productImageEl.src = image_url;
      productImageEl.src = isValidImageUrl(image_url) ? image_url : fallbackImage;
      productImageEl.alt = title;
       productImageEl.onerror = function () {
        this.onerror = null;
        this.src = fallbackImage;
      };
    }
    
        // ✅ Update Quantity
        var productQtyEl = tempContainer.querySelector(".quantity__input");
        if (productQtyEl) {
            productQtyEl.value = qty;
        }
    }

  
    // Create a new <tr> element for the free item
    var freeTr = document.createElement("tr");
    freeTr.id = originalTr.id + "-free-"+variantId; // e.g., "CartDrawer-Item-1-free"
    var freeItemId = freeTr.id;
    var existingFreeTr = document.getElementById(freeItemId);
    if (existingFreeTr) {
        existingFreeTr.remove();
        //console.log("Removed existing free item row:", freeItemId);
    }
     if (variantId !== parent_id) {
       freeTr.setAttribute("data-free-for", variantId);
       freeTr.setAttribute("data-itemid", variantId);
     }else{
        freeTr.setAttribute("data-free-for", knownDataItemId);
     }
    freeTr.classList.add("cart-item", "free-item");
    freeTr.classList.add("remove-"+variantId);
    // Set the modified innerHTML to the new free row
    freeTr.innerHTML = tempContainer.innerHTML;
    
    // Insert the new free row immediately after the original row
    originalTr.parentNode.insertBefore(freeTr, originalTr.nextSibling);


  
}
function getSafeImageUrl(url) {
  const fallbackImage = "https://raf-pharmacy.myshopify.com/cdn/shop/files/place_holder-back_ad_white.png?v=1738557147&width=100";
  if (typeof url !== 'string' || url.includes('Liquid error') || url.trim() === '') {
    return fallbackImage;
  }

  // Add https: if protocol is missing
  if (url.startsWith('//')) {
    return 'https:' + url;
  }

  // If it looks valid, return as is
  if (url.startsWith('http')) {
    return url;
  }

  // Everything else — fallback
  return fallbackImage;
}
function addFreeItem(item) {
  //console.log("addFreeItem function", item);
  // Call your function to show free items in the cart page, if needed
  addFreeItemMainCart(item);
  
  var variantId = parseInt(item.variationId);
  var qty = item.Qty;
  var image_url = item.ImageUrl;
  var price = item.Price;
  var title = item.Title;
  var parent_id = parseInt(item.ParentId);
  //console.log("addFreeItem item:", item);
  // Try to locate the original <tr> element using parent's id
  var knownDataItemId = parent_id;
  var originalTr = document.querySelector('tr[data-itemid="' + knownDataItemId + '"]');
  
  // If the parent's row is not found, use the last cart item as a fallback template
  if (!originalTr) {
    //console.log("Original tr not found for data-itemid " + knownDataItemId + ". Using fallback template.");
    originalTr = document.querySelector('tr.cart-item:last-of-type');
    if (!originalTr) {
     // console.error("No cart item found to use as a template for free item.");
      return;
    }
  }
  
  // Get the innerHTML of the template row
  var originalHTML = originalTr.innerHTML;
  
  // Create a temporary container to modify the HTML
  var tempContainer = document.createElement("div");
  tempContainer.innerHTML = originalHTML;
  
  // Remove elements that shouldn't be duplicated
  var quantityPopover = tempContainer.querySelector("quantity-popover");
  if (quantityPopover) {
    quantityPopover.remove();
  }
  
  var productTags = tempContainer.querySelector("div.product-tags");
  if (productTags) {
    productTags.remove();
  }
  
  // Update the product option text to show "Free (QAR price)"
  var productOptionEl = tempContainer.querySelector(".product-option");
  if (productOptionEl) {
    productOptionEl.textContent = "Free (QAR " + price + ")";
  }
  
  // Update the cart remove button id to avoid conflicts
  var cartRemoveButton = tempContainer.querySelector("cart-remove-button");
  if (cartRemoveButton) {
    let oldId = cartRemoveButton.id;
    let newId = oldId + "-free-" + variantId;
    cartRemoveButton.id = newId;
  }
  
  // Append the free item quantity info to the product name
  var productNameEl = tempContainer.querySelector(".cart-item__name");
  if (productNameEl) {
    productNameEl.textContent += " (" + qty + " x Free)";
  }
  
  // If the free item is different from the parent (variantId !== parent_id),
  // update the details for image, title, and quantity
  if (variantId != parent_id) {
    //console.log("🔄 Updating Free Item Details: New Title, Image, Price, and Quantity.");
    if (productNameEl) {
      productNameEl.textContent = title + " (" + qty + " x Free)";
    }
    var productImageEl = tempContainer.querySelector(".cart-item__image");
    //const fallbackImage = "https://raf-pharmacy.myshopify.com/cdn/shop/files/place_holder-back_ad_white.png?v=1738557147&width=100";

// Check if image_url is valid
   
    if (productImageEl) {
      // alert(image_url);
      const safeImageUrl = getSafeImageUrl(image_url);
     // productImageEl.src = image_url;
      productImageEl.src = safeImageUrl;
      productImageEl.alt = title;
      //  productImageEl.onerror = function () {
      //   this.onerror = null;
      //   this.src = fallbackImage;
      // };
    }
    var productQtyEl = tempContainer.querySelector(".quantity__input");
    if (productQtyEl) {
      productQtyEl.value = qty;
    }
  }
  
  // Create a new <tr> element for the free item row
  var freeTr = document.createElement("tr");
  freeTr.id = originalTr.id + "-free-" + variantId; // e.g., "CartDrawer-Item-1-free-40758662070307"
  
  // Remove any existing free item row with the same id
  var freeItemId = freeTr.id;
  var existingFreeTr = document.getElementById(freeItemId);
  if (existingFreeTr) {
    existingFreeTr.remove();
  }
  
  // Set data attributes:
  // - If the free item is different from the parent, assign the free row to the variantId.
  // - Otherwise, use the parent's id.
  if (variantId !== parent_id) {
    freeTr.setAttribute("data-free-for", variantId);
    freeTr.setAttribute("data-itemid-free", variantId);
    freeTr.classList.add("remove-"+variantId);
  } else {
    freeTr.setAttribute("data-free-for", knownDataItemId);
    freeTr.classList.add("remove-"+variantId);
    freeTr.setAttribute("data-itemid-free", variantId);
  }
  
  freeTr.classList.add("cart-item", "free-item");
  
  // Set the modified innerHTML to the new free row
  freeTr.innerHTML = tempContainer.innerHTML;
  
  // Insert the new free row:
  // - If the original row was found by parent's id, insert immediately after it.
  // - Otherwise, if using a fallback, append the free row at the end of the cart.
  if (originalTr.nextSibling) {
    originalTr.parentNode.insertBefore(freeTr, originalTr.nextSibling);
  } else {
    originalTr.parentNode.appendChild(freeTr);
  }
}

//freeItenms data save to local storage
/**
 * Saves the current freeItems array to localStorage.
 */
function saveFreeItems(STORAGE_KEY,freeItems) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(freeItems));
}
/**
 * Updates the freeItems array by adding a new item or updating an existing one.
 * Also saves the updated array to localStorage.
 *
 * @param {string|number} variationId - The unique identifier for the item.
 * @param {number} qty - The quantity to add or remove.
 * @param {string} action - The action to perform ('add' to increase, 'remove' to decrease).
 */
function updateFreeItems(variationId,qty,action = 'add',title='',image_url='',vendor='',price='', parentId=0, offerType=''){
 
//alert("UpdateFreeItems");
  // Check if an item with the given variationId already exists
  const STORAGE_KEY = 'freeItems';
  
if(parentId==0){
  //if free item addin for same items in cart, then parent id will be same as free item id
  parentId = variationId;
}
  variationId = parseInt(variationId);
//parentId=0;  
// Load freeItems from localStorage or start with an empty array
var freeItems = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    //console.log("before Updated free items: ");
//console.log(freeItems);
  const messageDiv = document.querySelector('.out-of-stock-message');
  let index;
  //alert(action);
  if(action === 'add'){
    index = freeItems.findIndex(item => item.variationId == variationId);
  }else{
    index = freeItems.findIndex(item => item.variationId == variationId || item.ParentId==parentId);
  }
  //const index = freeItems.findIndex(item => item.variationId == variationId);
  if (index !== -1) {
    //alert('exist');
    // If the item exists, update the Qty based on the action
    if (action === 'add' ) {
      freeItems[index].Qty += qty;
    } else if (action === 'remove') {
      freeItems[index].Qty -= qty;
      // Optionally, remove the item if the quantity is zero or less
      if (freeItems[index].Qty <= 0) {
        freeItems.splice(index, 1);
      }
    }
  } else {
    // If the item does not exist and the action is 'add', add a new item
    if (action === 'add') {
      //check stock available
      if(parentId == variationId){
        ///alert("Hhhhhhhhhhhhhhhh");
          const quantityInput = document.querySelector(`input[data-quantity-variant-id="${parentId}"]`);
          //existing cart item qty
          const cartQuantity = quantityInput ? quantityInput.getAttribute('data-cart-quantity') : null;
          //total stock available
          const current_stock = quantityInput ? quantityInput.getAttribute('stock') : null;
        //alert("current stock" + current_stock);
          const totalQty = parseInt(cartQuantity) + parseInt(qty);
          if(current_stock>=totalQty){
             freeItems.push({ variationId, Qty: qty,Title: title,ImageUrl: image_url, Vendor: vendor,ParentId: parentId, Price: price,Tag: offerType});
             messageDiv.textContent = "";
          }else{
           //alert("Sorry, stock not availale for free items you selected");
            
            messageDiv.textContent = "Sorry, stock not availale for free items you selected";
          }
      }else{
        //alert("adding free items");
          freeItems.push({ variationId, Qty: qty,Title: title,ImageUrl: image_url, Vendor: vendor,ParentId: parentId, Price: price,Tag: offerType});
          messageDiv.textContent = "";
      }
    }
  }
  //console.log("After Updated free items: ");
//console.log(freeItems);
  // console.log("End Updated free items: ");
  // Save updated freeItems to localStorage
  saveFreeItems(STORAGE_KEY,freeItems);
}

//managing localStorage for page load
document.addEventListener("DOMContentLoaded", function () {
    //console.log("Checking Shopify cart...");

    // Fetch Shopify cart data
    fetch("/cart.js")
        .then(response => response.json())
        .then(cart => {
            //console.log("Cart items loaded:", cart.items);

            if (cart.items.length === 0) {
               // console.log("Cart is empty. Resetting freeItems...");
                localStorage.removeItem("freeItems"); // Clear freeItems from localStorage
               // console.log(localStorage.getItem("freeItems"));
            } else {
                // Show free items if cart has products
                showFreeItemsInCart('initialize');
                showEligibleFreeMessage();
                
            }
        })
        .catch(error => console.error("Error fetching cart:", error));
      
});

//function enable / disable custom checkout button
function manageCheckoutButton() {
  // Get all matching elements
  let checkoutOfferBtns = document.querySelectorAll('.CartDrawer-Checkout-offer');
  let checkoutBtns = document.querySelectorAll('.CartDrawer-Checkout');
  if (checkoutOfferBtns.length === 0 || checkoutBtns.length === 0) {
    //console.error("❌ Checkout buttons not found!");
    return;
  }

  // Check localStorage for freeItems
  let freeItems = JSON.parse(localStorage.getItem("freeItems")) || [];

  if (freeItems.length > 0) {
 // console.log("✅ Free items found, showing offer checkout button.");
  checkoutOfferBtns.forEach(btn => {
    btn.style.display = "block";
    btn.disabled = false; // enable the button
  });
  checkoutBtns.forEach(btn => {
    btn.style.display = "none";
    // Optionally disable the normal checkout button
    btn.disabled = true;
  });
} else {
 // console.log("❌ No free items, showing normal checkout button.");
  checkoutOfferBtns.forEach(btn => {
    btn.style.display = "none";
    btn.disabled = true;
  });
  checkoutBtns.forEach(btn => {
    btn.style.display = "block";
   // btn.disabled = false; // enable the button
  });
}
}
function removeFreeItemsDirectly(variantId, eligibleFree = 0,tag='',vendor='') {
     let freeItems = JSON.parse(localStorage.getItem("freeItems")) || [];
 // alert("remove free items");
   //console.log(`✅ before remove freeItems:`, freeItems);
    // ✅ Check each item and modify the list based on `eligibleFree`
    let updatedFreeItems = freeItems.map(item => {
        if (item.variationId == variantId || item.ParentId == variantId) {
          //alert('Remove items found');
            if (item.Qty == eligibleFree || eligibleFree==0) {
                //console.log(`✅ Removing ${item.Qty} free items (Fully Removed)`);
                return null; // Remove item
            } else if (item.Qty > eligibleFree) {
               // console.log(`🔹 Reducing ${eligibleFree} free items from ${item.Qty}`);
                item.Qty -= eligibleFree; // Reduce quantity
                return item;
            }
        }
        return item;
    }).filter(item => item !== null); // Remove `null` entries (fully removed items)
    // ✅ Update localStorage
    localStorage.setItem("freeItems", JSON.stringify(updatedFreeItems));
    //console.log(`✅ After Remove freeItems:`, updatedFreeItems);
    showEligibleFreeMessage();
}
function removeFreeItems(variantId, eligibleFree = 0, tag = '', vendor = '') {
  // Get allowed free quantity for this tag/vendor combination
  let freeQtyAllowed = getTotalEligbleFreeItems(tag, vendor, 0, 'remove');
  //alert("freeQtyAllowed: " + freeQtyAllowed);

  // Retrieve the free items array from localStorage
  let freeItems = JSON.parse(localStorage.getItem("freeItems")) || [];
  //console.log("✅ before remove freeItems:", freeItems);

  // First, filter items that match both the variant/parent condition and the tag
  const matchingItems = freeItems.filter(
    item => item.Tag === tag
  );

  // Calculate the total quantity of matching free items
  let totalMatchingQty = matchingItems.reduce((acc, item) => acc + item.Qty, 0);
  //alert("totalMatchingQty: " + totalMatchingQty);
  // Determine how many free items need to be removed
  let extra = totalMatchingQty - freeQtyAllowed;

  // Update freeItems: for items that match the variant/parent and tag, remove/reduce quantity if extra > 0
  let updatedFreeItems = freeItems
    .map(item => {
      // Only update items that match both the variant/parent condition and the tag
      if (item.Tag === tag) {
        if (extra > 0) {
          // If the item quantity is less than or equal to the extra amount, remove this item entirely
          if (item.Qty <= extra) {
            extra -= item.Qty;
            return null;
          } else {
            // Otherwise, reduce its quantity by the extra amount and set extra to 0
            item.Qty -= extra;
            extra = 0;
            return item;
          }
        }
      }
      // For items that don't match or when no removal is needed, return as is
      return item;
    })
    .filter(item => item !== null); // Remove any null entries

  // Update localStorage and log the results
  localStorage.setItem("freeItems", JSON.stringify(updatedFreeItems));
  //console.log("✅ After Remove freeItems:", updatedFreeItems);
  showEligibleFreeMessage();
}
function showFreeItemsInCart(status=''){
  //alert("Show free items");
  
  const STORAGE_KEY = 'freeItems';
        // Load freeItems from localStorage or start with an empty array
        var freeItems = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
       // Retrieve and parse 'freeItems' from localStorage
      //console.log("Show free items: ",freeItems);
     // console.log(freeItems);
      // Loop through each item and log variantId and qty
      freeItems.forEach((item, index) => {
          //console.log(`Item ${index + 1}: Variant ID: ${item.variationId}, Quantity: ${item.Qty}`);
        addFreeItem(item);
        if( window.location.pathname!="/cart" && window.location.pathname!="/ar/cart" && status==''){
          
          openCartDrawer('main');
        }
      });
    showEligibleFreeMessage();
    manageCheckoutButton(); //disable / enable custom checkout button
    //pj code, load cart items to localstorage
          fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
             //console.log("after added cart items:", cart.items);
                localStorage.setItem("loadedCartItems", JSON.stringify(cart));
            // You can loop through items or manipulate as needed
          })
          .catch(error => console.error("Error fetching cart:", error));
}

function manageFreeItemsQtyIncrement(line,quantity,variantId,name){
 // return false;
 //alert("variantId "+ variantId);
  //get price for the item
  let trId = document.getElementById(`CartDrawer-Item-${line}`);
   let vendor = trId.getAttribute("vendor");
   let title='';
   let image_url='';
  //get price
  if (trId) {
  const priceElement = trId.querySelector(".product-option");
  const priceText = priceElement ? priceElement.textContent.trim() : null;
  //console.log("Item Price:", priceText); // Example output: "1 x QAR 79.00"
  // Optional: Extract just the numeric price (e.g., "QAR 79.00")
  const priceMatch = priceText.match(/QAR\s[\d.,]+/);
  var price = priceMatch ? priceMatch[0] : null;
  price = price.replace("QAR ","",price);
  } 
  // alert(price);
  //end

  
  var classUsed = getFirstDivClasses(variantId);  //find out all class added for div inside tr
   //alert("classUsed "+ classUsed);
   
  let currentCartQty;
   var quantityElement;
  
   if (window.location.pathname == '/cart' || window.location.pathname == '/ar/cart') {
      var quantityElementMainCart = document.getElementById(`Quantity-${line}`);
      quantityElement = document.getElementById(`Drawer-quantity-${line}`);
     currentCartQty = quantityElement.value;
   }else{
     quantityElement = document.getElementById(`Drawer-quantity-${line}`);
     currentCartQty = quantityElement.value;
   }
  let existingQty = quantity - 1;
  if(quantity==0){ //usertry to remove item from cart
    //clear freeItems for variantId
    if(classUsed.indexOf("buy-2-get-1") > -1) {
        var tag="buy-2-get-1";
        var freeQty = Math.floor((quantity - 1) / 2);
    }else if(classUsed.indexOf("buy-1-get-1") > -1) {
      var freeQty = currentCartQty;
       var tag="buy-1-get-1";
    }
    
    var trElement = document.querySelector(`tr[data-itemid="${variantId}"]`);
    if (trElement) {
    // Get the vendor attribute value
    var vendorValue = trElement.getAttribute("vendor");
     
  }else{
      var vendorValue='';
  }
    loadedCartItemsLocalStorage(0,variantId);
    removeFreeItems(variantId,freeQty,tag,vendorValue);
    //
    showFreeItemsInCart();
  }else{
    
     if(classUsed.indexOf("buy-2-get-1") > -1){
        var freeQty = Math.floor(existingQty / 2);
        var offerType="buy-2-get-1";
      }else if(classUsed.indexOf("buy-1-get-1") > -1) {
        var freeQty = existingQty;
        var offerType="buy-1-get-1";
      }
     //alert('offerType '+offerType);
      var trElement = document.querySelector(`tr[data-itemid="${variantId}"]`);
      if (trElement) {
          // Get the vendor attribute value
          var vendorValue = trElement.getAttribute("vendor");
      }else{
          var vendorValue='';
      }
    
   // let lowestPriceItems=checkSameVendorItemsInCart(vendorValue, variantId, quantity, offerType, price);
     var currentFreeQty = searchItemsInFreeItems(variantId);
    const cart = JSON.parse(localStorage.getItem("loadedCartItems"));
    //console.log('current cart items after increment: ', cart);
    //alert('currentFreeQty '+currentFreeQty);
   // alert('offerType '+offerType);
   // alert('vendorValue '+vendorValue);
     //freeQty = getTotalEligbleFreeItems(offerType,vendorValue,quantity);
    // alert('free qty '+freeQty);
    //return false;
     if(freeQty > currentFreeQty){
         //get vendor from tr attribute
         //CartDrawer-Item-1
         let trId = document.getElementById(`CartDrawer-Item-${line}`);
         let vendor = trId.getAttribute("vendor");
         let title='';
         let image_url='';
       //get price
        if (trId) {
        const priceElement = trId.querySelector(".product-option");
        const priceText = priceElement ? priceElement.textContent.trim() : null;
        //console.log("Item Price:", priceText); // Example output: "1 x QAR 79.00"
        // Optional: Extract just the numeric price (e.g., "QAR 79.00")
        const priceMatch = priceText.match(/QAR\s[\d.,]+/);
        var price = priceMatch ? priceMatch[0] : null;
        price = price.replace("QAR ","",price);
       } 
         //updateFreeItems(variationId,qty,action = 'add',title='',image_url='',vendor='',price='', parentId=0)
         var parentId=0;
         updateFreeItems(variantId,1,"add",title,image_url,vendor,price,parentId,offerType); //add free items to local storage
          if (window.location.pathname === '/cart' || window.location.pathname==='/ar/cart') {
             quantityElement.value=quantity-1;
             quantityElementMainCart.value=quantity-1;
          }else{
            quantityElement.value=quantity-1;
          }
         showFreeItemsInCart();
         return true;
     }else if(freeQty < currentFreeQty){
       //alert('remove item');
       let trId = document.getElementById(`CartDrawer-Item-${line}`);
       let vendor = trId.getAttribute("vendor");
       let title='';
       let image_url='';
       updateFreeItems(variantId,1,"remove",title,image_url,vendor,price,parentId,offerType); //remove free items to local storage
       showFreeItemsInCart();
     }
  }
  return false;
}
function getCurrentTotalFreeItems(vendorTag,vendorValue) {
    let cartFreeItems = JSON.parse(localStorage.getItem("freeItems")) || []; // Stored free items
        // Loop through each cart item
    let Qty=0;
          cartFreeItems.forEach((item, index) => {
           //if(variantId==item.variationId){
           if(vendorValue==item.Vendor && vendorTag==item.Tag ){
             Qty = item.Qty + Qty;
           }
        });
    return Qty;
}
function manageFreeItemsQtyIncrement34343434(line,quantity,variantId,name){
  
 // return false;
//  alert("quantity "+ quantity);
  //get price for the item
  let trId = document.getElementById(`CartDrawer-Item-${line}`);
   let vendor = trId.getAttribute("vendor");
   let title='';
   let image_url='';
  //get price
  if (trId) {
  const priceElement = trId.querySelector(".product-option");
  const priceText = priceElement ? priceElement.textContent.trim() : null;
  //console.log("Item Price:", priceText); // Example output: "1 x QAR 79.00"
  // Optional: Extract just the numeric price (e.g., "QAR 79.00")
  const priceMatch = priceText.match(/QAR\s[\d.,]+/);
  var price = priceMatch ? priceMatch[0] : null;
  price = price.replace("QAR ","",price);
  } 
  // alert(price);
  //end
  var classUsed = getFirstDivClasses(variantId);  //find out all class added for div inside tr
  let currentCartQty;
   var quantityElement;
  
   if (window.location.pathname == '/cart' || window.location.pathname=='/ar/cart') {
      var quantityElementMainCart = document.getElementById(`Quantity-${line}`);
      //quantityElement = document.getElementById(`Drawer-quantity-${line}`);
     currentCartQty = quantityElementMainCart.value;
   }else{
     quantityElement = document.getElementById(`Drawer-quantity-${line}`);
     currentCartQty = quantityElement.value;
   }
 
  let existingQty = quantity - 1;
  if(quantity==0){ //usertry to remove item from cart
    //clear freeItems for variantId
    if(classUsed.indexOf("buy-2-get-1") > -1) {
        var tag="buy-2-get-1";
        var freeQty = Math.floor((quantity - 1) / 2);
    }else if(classUsed.indexOf("buy-1-get-1") > -1) {
      var freeQty = currentCartQty;
       var tag="buy-1-get-1";
    }
    var trElement = document.querySelector(`tr[data-itemid="${variantId}"]`);
    if (trElement) {
    // Get the vendor attribute value
    var vendorValue = trElement.getAttribute("vendor");
     
  }else{
      var vendorValue='';
  }
    loadedCartItemsLocalStorage(0,variantId);
    removeFreeItems(variantId,freeQty,tag,vendorValue);
    //
    showFreeItemsInCart();
    return false;
  }else{
    let offerType1;
     if(classUsed.indexOf("buy-2-get-1") > -1){
      var freeQty = Math.floor(existingQty / 2);
      offerType1="buy-2-get-1";
    }else if(classUsed.indexOf("buy-1-get-1") > -1) {
      var freeQty = existingQty/2;
      offerType1="buy-1-get-1";
    }
    
   //  alert('offerType '+offerType1);
    //return;
      var trElement = document.querySelector(`tr[data-itemid="${variantId}"]`);
      if (trElement) {
          // Get the vendor attribute value
          var vendorValue = trElement.getAttribute("vendor");
      }else{
          var vendorValue='';
      }
   
    //let lowestPriceItem=checkSameVendorItemsInCart(vendorValue, variantId, quantity, offerType, price);
     let lowestPriceItem = checkSameVendorItemsLocalStorage(vendorValue, variantId, quantity, offerType1, price);
     //console.log("lowestPriceItem available ",  lowestPriceItem.price);    
   // return true;
    //.then(lowestPriceItem => {
      var quantityElementMainCart = document.getElementById(`Quantity-${line}`);
     
       freeQty = getTotalEligbleFreeItems(offerType1,vendorValue,quantity);
        var currentFreeQty = getCurrentTotalFreeItems(offerType1,vendorValue);
       // alert('currentFreeQty '+currentFreeQty);
      //let totalSameVenor=getTotalExistingVendorItems(offerType1,vendorValue);
      currentCartQty = getCurrentCartQty(variantId);
      let newQty=0;
      if(quantity > currentCartQty){
        newQty = quantity - currentCartQty;
      }else{
        newQty = parseInt(quantity);
        freeQty = 0;
      }
      // alert('free qty www '+freeQty);
      // alert("newQty "+ newQty);
        let balanceFreeQty=0;
        if(offerType1 == "buy-2-get-1" && newQty > 2){
          var freeQty1 = Math.floor(newQty/ 2);
          var offerType="buy-2-get-1";
        }else if(offerType1 == "buy-1-get-1" && newQty>1) {
          var freeQty1 = Math.floor(newQty/ 2);
          var offerType="buy-1-get-1";
        }else{
          var freeQty1=0;
        }
        
     // alert("freeQty balance "+ freeQty1);
     
     
           if(freeQty > 0 && lowestPriceItem && price > lowestPriceItem.price && freeQty <=lowestPriceItem.quantity){
             // if(lowestPriceItem.quantity > freeQty){
             //   let switchQty = lowestPriceItem.quantity - freeQty;
             // }else{
             //   let switchQty = lowestPriceItem.quantity - freeQty;
             // }
             //alert("Switch items");
              switchCartItems(variantId,price,freeQty,lowestPriceItem,"remove",offerType1);
              //return true;  
           }else if(freeQty > 0 && lowestPriceItem && price > lowestPriceItem.price && freeQty >lowestPriceItem.quantity){
             let balanceFreeQty = freeQty - lowestPriceItem.quantity;
             switchCartItems(variantId,price,lowestPriceItem.quantity,lowestPriceItem,"switch",offerType1);
             return true;
           }else if(freeQty >0 && newQty==1){
            // alert("same item not found");
             let title='';
             let image_url='';
             updateFreeItems(variantId,newQty,"add",title,image_url,vendorValue,price,variantId,offerType1);
              if (window.location.pathname === '/cart' || window.location.pathname==='/ar/cart') {
                     
                    // quantityElement.value=newQty;
                     quantityElementMainCart.value=quantity - newQty;
                  }else{
                    quantityElement.value=newQty;
                  }
             showFreeItemsInCart();
             return true;
           }else{
               balanceFreeQty = balanceFreeQty + freeQty1;
               if(balanceFreeQty < currentFreeQty){
                 //adjust free items for same vendor and tag
                 let adjustQty = currentFreeQty - balanceFreeQty;
                // adjustExistingFreeItems(adjustQty);
               }
               // alert("freeQty balance "+ balanceFreeQty);
               newQty = newQty - balanceFreeQty;
             //alert("Final balance "+ newQty);
              // alert("adding rest of the items to cart");
               if (window.location.pathname === '/cart' || window.location.pathname==='/ar/cart') {
                     
                    // quantityElement.value=newQty;
                     quantityElementMainCart.value=newQty;
                  }else{
                    quantityElement.value=newQty;
                  }
               let title='';
             let image_url='';
             if(balanceFreeQty>0 && balanceFreeQty > currentFreeQty){
               updateFreeItems(variantId,balanceFreeQty,"add",title,image_url,vendorValue,price,variantId,offerType1);
             }
              showFreeItemsInCart();
              return false;
           }
           
   // });
    
     
   // alert('currentFreeQty '+currentFreeQty);
   // alert('offerType '+offerType);
   // alert('vendorValue '+vendorValue);
     
    
    // return true;
  }
 //return true;
  return false;
}
function checkSameVendorItemsLocalStorage(vendorValue, variantId, quantity, offerType1, price) {
  const cartData = localStorage.getItem("loadedCartItems");
  if (!cartData) return null;

  let cart;
  try {
    cart = JSON.parse(cartData);
  } catch (e) {
    //console.warn("Invalid JSON in loadedCartItems");
    return null;
  }

  const cartItems = Array.isArray(cart)
    ? cart
    : Array.isArray(cart.items)
      ? cart.items
      : [];

  if (cartItems.length === 0) return null;

  let matchingItems = cartItems.filter(item => {
    if (item.vendor !== vendorValue) return false;

    const rawTags = item?.properties?._tags;
    if (!rawTags) return false;

    let tags = [];
    try {
      tags = JSON.parse(rawTags); // "_tags": "[\"bogo\",\"buy-1-get-1\"]"
    } catch (err) {
     // console.warn("Failed to parse tags for item", item);
      return false;
    }

    return tags.includes(offerType1);
  });

  if (matchingItems.length === 0) return null;

  // Find the lowest priced item
  let lowestItem = matchingItems.reduce((lowest, item) => {
    return (!lowest || item.final_price < lowest.final_price) ? item : lowest;
  }, null);

  if (!lowestItem) return null;

  return {
    variantId: lowestItem.id,
    quantity: lowestItem.quantity,
    price: lowestItem.final_price / 100,
    title: lowestItem.product_title,
    image_url: lowestItem.featured_image?.url || '',
    alt: lowestItem.featured_image?.alt || '',
    vendor: lowestItem.vendor
  };
}





//get class used in div to identify added items buy 1 get 1 or buy 2 get 1
function getFirstDivClasses(dataItemId) {
    // Locate the <tr> element using data-itemid
    let row = document.querySelector(`tr[data-itemid="${dataItemId}"]`);

    if (row) {
        // Find the first <div> inside the <tr>
        let firstDiv = row.querySelector("div");

        if (firstDiv) {
            let classList = [...firstDiv.classList]; // Convert classList to an array
            //console.log(`Classes for first <div> in <tr data-itemid="${dataItemId}">:`, classList);
            return classList; // Return the array of class names
        } else {
           // console.log(`No <div> found inside <tr data-itemid="${dataItemId}">`);
        }
    } else {
        //console.log(`No <tr> found with data-itemid="${dataItemId}"`);
    }

    return [];
}

function getCurrentCartQty(variantId){
  // Load cart data from localStorage
  const cartData = localStorage.getItem("loadedCartItems");
  //console.log("Loaded cart data from localStorage: ", cartData);
  let cart = cartData ? JSON.parse(cartData) : { items: [] };
  // Validate cart structure
  if (!cart.items || !Array.isArray(cart.items)) {
    //console.warn("Cart data structure is incorrect. Reinitializing.");
    return 0;
  }
  // Find the item by variantId
  const item = cart.items.find(item => item.variant_id == variantId);
  // Return the quantity if found, otherwise return 0
  return item ? item.quantity : 0;
}
//check same vendor exists in cart
async function checkSameVendorItemsInCart(vendorValue, variantId, quantity, vendorTag, productPrice) {
    // Load cart
 // alert(vendorTag);
    try {
        let response = await fetch("/cart.js");
        var cart = await response.json();
        //var loadedCartItems = cart;
        //console.log("Current Cart items loaded:", cart.items);
        localStorage.setItem("loadedCartItems", JSON.stringify(cart));
        //localStorage.setItem("loadedCartItems",cart.items);
        
        let matchingItems = [];
        let eligibleFree = 0;
        let totalQty=0;
        let totalCurrentFree=0;
        let currentFree=0;
        let totalBuy1get1=0;
        let totalBuy2get1=0;
        cart.items.forEach(item => {
            // Check if vendor matches and if vendorTag exists in item tags
          
            if (item.vendor === vendorValue && item.properties?._tags?.includes(vendorTag)) {
            
                matchingItems.push({
                    variantId: item.id,
                    quantity: item.quantity,
                    price: item.final_price / 100, // Convert cents to currency format
                    title: item.product_title,
                    image_url:item.featured_image.url,
                    alt:item.featured_image.alt,
                    vendor:item.vendor
                });
                totalQty = item.quantity + totalQty;
                if(vendorTag=='buy-1-get-1'){
                   totalBuy1get1 = totalBuy1get1 + item.quantity;
                }else if(vendorTag=='buy-2-get-1'){
                   
                   totalBuy2get1 = totalBuy2get1 + item.quantity;
                }
             // alert(item.id);
              currentFree=searchItemsInFreeItems(item.id) //same vendor total checking
              //alert("current free 234 " + currentFree);
              totalCurrentFree = totalCurrentFree + currentFree;
            }
        });
       if(vendorTag=="buy-2-get-1"){
         totalBuy2get1 = totalBuy2get1 + quantity;
       }
        if(totalBuy2get1 == 2){
            eligibleFree = 1;
        }else if(totalBuy2get1 > 2){
            eligibleFree = Math.floor((totalBuy2get1 - 1) / 2);  //calculating total free for buy 2 get 1 based on cart items
        }
        eligibleFree = eligibleFree + totalBuy1get1;
       //alert(" eligibleFree "+eligibleFree);
     // console.log("Eligigle free items: "+eligibleFree);
      //console.log("totalCurrentFree free items: "+totalCurrentFree);
         if(totalCurrentFree == eligibleFree){
          // alert("free item not available");
           return null;
         }
      //alert("free item available");
      //alert(matchingItems.length);
        if (matchingItems.length > 0) {
            // Find the item with the lowest price
            let lowestPriceItem = matchingItems.reduce((prev, curr) => prev.price < curr.price ? prev : curr);
            //console.log(`Found lowest-priced item with same Vendor & VendorTag:`, lowestPriceItem);
            
            return lowestPriceItem;
        } else {
           // console.log(`No matching items found for Vendor: ${vendorValue} and Tag: ${vendorTag}`);
            return null;
        }
    } catch (error) {
       // console.error("Error fetching cart:", error);
        return null;
    }
}
function openCartDrawer(page='') {
    // ✅ Prevent execution on the first page load/refresh
    if (sessionStorage.getItem("cartOpened")!="true" && page=='') {
        sessionStorage.setItem("cartOpened", "true");
        //console.log("🐀򰀀𘁆irst load detected, preventing cart drawer from opening.");
        return;
    }

    // ✅ Find cart icon and trigger click event
    let cartIcon = document.getElementById("cart-icon-bubble");

    if (cartIcon) {
        cartIcon.click(); // Simulate click event
        //console.log("✅ Cart icon clicked programmatically.");
    } else {
       // console.log("❌ Cart icon not found.");
    }
}

// ✅ Ensure sessionStorage resets when the page is reloaded
window.addEventListener("beforeunload", () => {
    sessionStorage.removeItem("cartOpened");
});

//function to show eligible free items message in footer of mini cart
async function showEligibleFreeMessage_old() {
    try {
        //Fetch Shopify cart
        let response = await fetch('/cart.js');
        let cart = await response.json();

        //console.log("Cart loaded:", cart.items);

        let eligibleFreeBuy2Get1 = 0; // Total free items eligible based on cart
        let eligibleFreeTotal = 0; // Total free items eligible based on cart
        let cartFreeItems = JSON.parse(localStorage.getItem("freeItems")) || []; // Stored free items
        //console.log('Free items:', cartFreeItems);
        // Loop through each cart item
        cart.items.forEach(item => {
            let tags = item.properties?._tags || [];

            if (tags.includes("buy-2-get-1")) {
                //eligibleFreeTotal += Math.floor(item.quantity / 2); // 1 free for every 2
                eligibleFreeBuy2Get1 += item.quantity; // 1 free for every 2
            } 
            if (tags.includes("buy-1-get-1")) {
                eligibleFreeTotal += item.quantity; // 1 free for every 1
            }
        });
      //alert("eligibleFreeBuy2Get1 "+eligibleFreeBuy2Get1);
      eligibleFreeBuy2Get1 = Math.floor(eligibleFreeBuy2Get1 / 2);
      //alert('eligibleFreeBuy2Get1 '+eligibleFreeBuy2Get1);
      
      eligibleFreeTotal = eligibleFreeTotal + eligibleFreeBuy2Get1;
        // Calculate current free items from localStorage
        let currentFreeTotal = cartFreeItems.reduce((sum, item) => sum + item.Qty, 0);
        let messageDivs = document.querySelectorAll(".free-eligible-notification"); // <-- fixed name

        if (eligibleFreeTotal > currentFreeTotal) {
            let remainingFree = eligibleFreeTotal - currentFreeTotal;
            messageDivs.forEach(function(div) {
                const currentPath = window.location.href;
                if (currentPath.includes('.com/ar')) {
                  div.innerHTML = `أنت مؤهل للحصول على ${remainingFree} منتجًا إضافيًا مجانيًا من نفس العلامة التجارية! أضفها الآن!`;
                }else{
                  div.innerHTML = `You are eligible for ${remainingFree} more free item(s) from same brand! Add them now!`;
                }
                div.style.display = "block";
            });
        } else {
            messageDivs.forEach(function(div) {
                div.style.display = "none";
            });
        }

    } catch (error) {
        //console.error("Error fetching cart:", error);
    }
}
async function showEligibleFreeMessage() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

       // console.log("Cart loaded:", cart.items);

        let eligibleMap = {}; // { "Vendor|Tag": count }
        const cartFreeItems = JSON.parse(localStorage.getItem("freeItems")) || [];

        // Step 1: Process cart items to count eligible free products by vendor & tag
        cart.items.forEach(item => {
            const vendor = item.vendor;
            let tags = [];

            try {
                tags = item.properties?._tags ? JSON.parse(item.properties._tags) : [];
            } catch (e) {
               // console.warn('Could not parse tags:', item.properties._tags);
            }

            tags.forEach(tag => {
                const key = `${vendor}|${tag}`;
                if (tag === "buy-2-get-1") {
                    eligibleMap[key] = (eligibleMap[key] || 0) + Math.floor(item.quantity / 2);
                } else if (tag === "buy-1-get-1") {
                    eligibleMap[key] = (eligibleMap[key] || 0) + item.quantity;
                }
            });
        });

       // console.log("Eligible before subtracting free items:", eligibleMap);

        // Step 2: Subtract already added free items (only if vendor & tag match)
        cartFreeItems.forEach(freeItem => {
            const freeVendor = freeItem.Vendor;
            const freeTag = freeItem.Tag;
            const key = `${freeVendor}|${freeTag}`;
            if (eligibleMap[key]) {
                eligibleMap[key] -= freeItem.Qty;
                if (eligibleMap[key] < 0) eligibleMap[key] = 0;
            }
        });

        //console.log("Eligible after subtracting free items:", eligibleMap);

        // Step 3: Sum up total remaining eligible free items
        const totalRemainingFree = Object.values(eligibleMap).reduce((sum, qty) => sum + qty, 0);
        const messageDivs = document.querySelectorAll(".free-eligible-notification");

        if (totalRemainingFree > 0) {
            messageDivs.forEach(div => {
                const isArabic = window.location.href.includes('.com/ar');
                div.innerHTML = isArabic
                    ? `أنت مؤهل للحصول على ${totalRemainingFree} منتجًا إضافيًا مجانيًا من نفس العلامة التجارية! أضفها الآن!`
                    : `You are eligible for ${totalRemainingFree} more free item(s) from the same brand! Add them now!`;
                div.style.display = "block";
            });
        } else {
            messageDivs.forEach(div => {
                div.style.display = "none";
            });
        }
    } catch (error) {
       // console.error("Error in showEligibleFreeMessage:", error);
    }
}







document.addEventListener("DOMContentLoaded", function () {
  // Delegate the click event to the parent of the CartDrawer-Checkout-offer elements
  let cartDrawer = document.querySelector('body'); // or any parent element that is already available

  // Listen for clicks on elements with class "CartDrawer-Checkout-offer"
  cartDrawer.addEventListener("click", async function (event) {
    if (event.target && event.target.classList.contains("CartDrawer-Checkout-offer")) {
    //  alert('CartDrawer-Checkout-offer 333');
     // console.log("Checkout Offer Button Clicked!");
      const button = event.target.closest(".CartDrawer-Checkout-offer");
       button.classList.add("progressing");
       const currentPath = window.location.href;
      const locationValue = event.target.getAttribute('location');
      let prescriptionId = validatePrescription(locationValue);
      
      let customerId = ShopifyAnalytics.meta.page.customerId;
      if (!customerId) {
        localStorage.setItem("offerCheckout", "1");
              
                if (currentPath.includes('.com/ar')) {
                  window.location.href = "/ar/account/login";
                }else{
                  window.location.href = "/account/login";
                }
        return;
      }
      
      let cartItems = await fetchShopifyCart();
      if (!cartItems.length) {
       // console.error("Cart is empty. Cannot proceed.");
         button.classList.remove("progressing");
        return;
      }
      
      let freeItems = JSON.parse(localStorage.getItem("freeItems")) || [];
      let draftOrderItems = mergeCartWithFreeItems(cartItems, freeItems);
      //console.log(draftOrderItems);
      
      let response = await sendDraftOrder(draftOrderItems, '', prescriptionId);
      if (response && response.checkout_url) {
        localStorage.setItem("offerCheckout", "0");
        button.classList.remove("progressing");
       
        if (currentPath.includes('.com/ar')) {
          window.location.href = response.checkout_url+"?locale=ar";
        }else{
           window.location.href = response.checkout_url;
        }
      } else {
        // console.error("Failed to create draft order.");
      }
    }
  });
});


/*
document.addEventListener("DOMContentLoaded", function () {
  // Select all elements with the class "CartDrawer-Checkout-offer"
  let checkoutOfferBtns = document.querySelectorAll(".CartDrawer-Checkout-offer");

  // If there are any buttons found
  if (checkoutOfferBtns.length > 0) {
    checkoutOfferBtns.forEach(btn => {
      btn.addEventListener("click", async function () {
        alert('CartDrawer-Checkout-offer');
        console.log("Checkout Offer Button Clicked!");
        const locationValue = this.getAttribute('location');
        let prescriptionId = validatePrescription(locationValue);
        // Uncomment and adjust the following code as needed
        let customerId = ShopifyAnalytics.meta.page.customerId;
        if (!customerId) {
          localStorage.setItem("offerCheckout", "1");
          window.location.href = "/account/login";
          return;
        }
        let cartItems = await fetchShopifyCart();
        if (!cartItems.length) {
          console.error("Cart is empty. Cannot proceed.");
          return;
        }
        let freeItems = JSON.parse(localStorage.getItem("freeItems")) || [];
        let draftOrderItems = mergeCartWithFreeItems(cartItems, freeItems);
        console.log(draftOrderItems);
        let response = await sendDraftOrder(draftOrderItems, '', prescriptionId);
        if (response && response.checkout_url) {
          localStorage.setItem("offerCheckout", "0");
         // console.log("Redirecting to checkout:", response.checkout_url);
          window.location.href = response.checkout_url;
        } else {
         // console.error("Failed to create draft order.");
        }
      });
    });
  }
}); */


function validatePrescription(location) {
 const prescriptionDropdown = document.getElementById(
  location === "main-cart" ? "prescription-dropdown-main-cart" : "prescription-dropdown"
);
  if (!prescriptionDropdown) {
    //console.log("Prescription dropdown not found.");
    return 0;
  }
  
  // Create or retrieve the warning message element
  let warningMessage = document.getElementById("prescription-warning-message");
  if (!warningMessage) {
    warningMessage = document.createElement("div");
    warningMessage.id = "prescription-warning-message";
    warningMessage.style.color = "red";
    warningMessage.style.fontSize = "14px";
    warningMessage.style.marginTop = "5px";
    // Insert the warning message right after the dropdown
    prescriptionDropdown.parentNode.insertBefore(warningMessage, prescriptionDropdown.nextSibling);
  }
  
  // Log the current selection for debugging
 // console.log("Dropdown selectedIndex:", prescriptionDropdown.selectedIndex);
 // console.log("Dropdown value:", prescriptionDropdown.value);
  
  // If the value is empty, show warning; otherwise, clear warning and return value
  if (prescriptionDropdown.value === "") {
    warningMessage.textContent = "Please select a patient to continue.";
    return false;
  } else {
    warningMessage.textContent = "";
    const selectedPatient = prescriptionDropdown.value;
    //console.log("Selected patient:", selectedPatient);
    return selectedPatient;
  }
}


  
async function startCheckoutProcess(email) {
   let cartItems = await fetchShopifyCart();
  if (!cartItems.length) {
    //console.error("Cart is empty. Cannot proceed.");
    return;
  }
  let prescriptionId=0;
  // Step 3: Get Free Items from LocalStorage
  let freeItems = JSON.parse(localStorage.getItem("freeItems")) || [];

  // Step 4: Combine cart and free items
  let draftOrderItems = mergeCartWithFreeItems(cartItems, freeItems);
  //console.log(draftOrderItems);

  // Step 5: Send Data to API
  let response = await sendDraftOrder(draftOrderItems,email,prescriptionId);
  if (response && response.checkout_url) {
   // console.log("Redirecting to checkout:", response.checkout_url);
    localStorage.setItem("offerCheckout", "0");
    const currentPath = window.location.href;
        if (currentPath.includes('.com/ar')) {
            window.location.href = response.checkout_url+"?locale=ar"; // Redirect to checkout
        }else{
          window.location.href = response.checkout_url; // Redirect to checkout
        }
  } else {
    //console.error("Failed to create draft order.");
  }
}
// Function to Check Customer Login Status
async function checkCustomerLogin() {
    try {
        let response = await fetch("/account"); // Shopify will redirect to login if not logged in
        return response.url.includes("/account") && !response.redirected;
    } catch (error) {
        //console.error("Error checking login status:", error);
        return false;
    }
}

// Function to Fetch Shopify Cart Items
async function fetchShopifyCart() {
    try {
        let response = await fetch("/cart.js");
        let data = await response.json();
       // console.log("Cart Items:", data.items);
        return data.items;
    } catch (error) {
       // console.error("Error fetching cart:", error);
        return [];
    }
}

// ✅ Function to Merge Cart Items with Free Items
function mergeCartWithFreeItems(cartItems, freeItems) {
    let mergedItems = [...cartItems];

    freeItems.forEach(freeItem => {
        // Find parent item in cart to get image and title
        let parentItem = cartItems.find(item => item.id == freeItem.ParentId);
      //console.log('parentItem');
      //console.log(parentItem);
        mergedItems.push({
            title: parentItem ? parentItem.title + " (Free)" : "Free Item",
            quantity: freeItem.Qty,
            price: freeItem.Price, // Free item should have price 0
            variant_id: freeItem.variationId,
            vendor: freeItem.Vendor,
            tag: freeItem.Tag,
            parentId:freeItem.ParentId,
            url: parentItem ? parentItem.featured_image.url : "",
            is_free: true
        });
    });

   // console.log("Combined Cart & Free Items:", mergedItems);
    return mergedItems;
}

//Function to Send Draft Order via AJAX
async function sendDraftOrder(orderItems,email,prescriptionId) {
    try {
        //Get logged-in customer ID from Shopify object
        let customerId = ShopifyAnalytics.meta.page.customerId || 0;
        if (!customerId && !email) {
            //console.error("No logged-in customer ID found.");
            return null;
        }
        let response = await fetch("https://app.rafpharmacy.com/api/offer/post.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                action: "createoffer", // Added action parameter
                id: customerId, // Added customer ID
                items: orderItems,
                email: email,
                prescriptionId: prescriptionId
            })
        });
    
        return await response.json();
    } catch (error) {
        //console.error("Error sending draft order:", error);
        return null;
    }
}



// ✅ Run function when cart page loads
//document.addEventListener("DOMContentLoaded", showEligibleFreeMessage);

function syncPrescriptionDropdowns() {
  const dropdowns = document.querySelectorAll(".prescription-dropdown");

  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener("change", function () {
      const selectedValue = this.value;

      dropdowns.forEach((otherDropdown) => {
        // Skip updating the dropdown that triggered the event
        if (otherDropdown !== this && otherDropdown.value !== selectedValue) {
          otherDropdown.value = selectedValue;

          // Only trigger event if value was actually different
          const event = new Event('input', { bubbles: true });
          otherDropdown.dispatchEvent(event);
        }
      });

      // Call your prescription processing function only once
      attachPrescriptionDropdownListeners();
    });
  });
}

document.addEventListener("DOMContentLoaded", syncPrescriptionDropdowns);
